import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'
import CustomScrollbars from 'react-custom-scrollbars'

export function Scrollbars(props) {
  const theme = useContext(ThemeContext)
  const { vertical, horizontal, ...restProps } = props

  const renderTrackHorizontal = useCallback(({ style, ...props }) => {
    const finalStyle = {
      ...style,
      right: 2,
      bottom: 2,
      left: 2,
    }
    return <div style={finalStyle} {...props} />
  }, [])

  const renderTrackVertical = useCallback(({ style, ...props }) => {
    const finalStyle = {
      ...style,
      right: 2,
      bottom: 2,
      top: 2,
    }
    return <div style={finalStyle} {...props} />
  }, [])

  const renderThumbHorizontal = useCallback(({ style, ...props }) => {
    const finalStyle = {
      ...style,
      cursor: 'pointer',
      display: horizontal ? 'block' : 'none',
      backgroundColor: theme.scrollbar.color,
    }
    return <div style={finalStyle} {...props} />
  }, [theme, horizontal])

  const renderThumbVertical = useCallback(({ style, ...props }) => {
    const finalStyle = {
      ...style,
      display: vertical ? 'block' : 'none',
      cursor: 'pointer',
      backgroundColor: theme.scrollbar.color,
    }
    return <div style={finalStyle} {...props} />
  }, [theme, vertical])

  return (
    <CustomScrollbars
      renderThumbHorizontal={renderThumbHorizontal}
      renderThumbVertical={renderThumbVertical}
      renderTrackHorizontal={renderTrackHorizontal}
      renderTrackVertical={renderTrackVertical}
      {...restProps}
    />
  )
}

Scrollbars.propTypes = {
  vertical: PropTypes.bool,
  horizontal: PropTypes.bool,
  autoHeight: PropTypes.bool,
}

Scrollbars.defaultProps = {
  vertical: true,
  horizontal: true,
  autoHeight: false,
}

export default Scrollbars
